"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _BannerModal = _interopRequireDefault(require("./components/BannerModal.vue"));
var _banner = require("@/api/banner.api");
var BannerPage = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BannerPage, _Vue);
  var _super = (0, _createSuper2.default)(BannerPage);
  function BannerPage() {
    var _this;
    (0, _classCallCheck2.default)(this, BannerPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "total", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "query", {
      page: 1,
      limit: 10,
      from: "",
      to: ""
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", [(0, _moment.default)().subtract(1, "months").format("YYYY-MM-DD"), (0, _moment.default)().format("YYYY-MM-DD")]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    return _this;
  }
  (0, _createClass2.default)(BannerPage, [{
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(row) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$confirm("Xác nhận xóa tin tức?", "Cảnh báo", {
                  confirmButtonText: "Xóa",
                  cancelButtonText: "Không",
                  type: "warning"
                });
              case 2:
                this.$set(row, "loadingDelete", true);
                _context.prev = 3;
                _context.next = 6;
                return _banner.bannerApi.remove(row.id);
              case 6:
                this.fetchData();
              case 7:
                _context.prev = 7;
                this.$set(row, "loadingDelete", false);
                return _context.finish(7);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 7, 10]]);
      }));
      function handleDelete(_x) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.BannerModal.handleUpdate(row);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.BannerModal.handleCreate();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.loading = true;
      this.query.from = this.date[0];
      this.query.to = this.date[1];
      _banner.bannerApi.findAll(this.query).then(function (res) {
        _this2.data = res.data.banners;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }]);
  return BannerPage;
}(_vuePropertyDecorator.Vue);
BannerPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    BannerModal: _BannerModal.default
  }
})], BannerPage);
var _default = BannerPage;
exports.default = _default;